import { render, staticRenderFns } from "./CommentModal.vue?vue&type=template&id=f5346d8c&scoped=true&"
import script from "./CommentModal.vue?vue&type=script&lang=js&"
export * from "./CommentModal.vue?vue&type=script&lang=js&"
import style0 from "./CommentModal.vue?vue&type=style&index=0&id=f5346d8c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5346d8c",
  null
  
)

export default component.exports